import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { flatMap } from "../../../utils/lodash";
import useStyles from "./GoToQuestionPanel.styles";
import { StoreState } from "../../../models/states/StoreState";
import { navigationBranchTo } from "../../../redux/actions";
import useScrollToActive from "../../../hooks/useScrollToActive";
import WidgetPanel from "./WidgetPanel";
import { QuestionType } from "../../../models/enums/QuestionType";

export function GoToQuestionPanel() {
    const containerRef = React.useRef();
    const classes = useStyles({});
    const dispatch = useDispatch();
    const blocks = useSelector((state: StoreState) => state.interview.questionnaire?.blocks);
    const pageQuestions = useSelector(
        (state: StoreState) => state.interview.navigation.currentPage?.questions,
    );
    const questions = React.useMemo(() => flatMap(blocks, (b) => b.questions) || [], [blocks]);
    const [search, setSearch] = React.useState("");
    const firstQuestion = pageQuestions && pageQuestions[0];
    const filteredQuestions = React.useMemo(() => {
        if (!search.length) return questions;
        const lowerCaseSearch = search.toLowerCase();
        return questions.filter((q) =>
            q.name.toLowerCase().includes(lowerCaseSearch.toLowerCase()),
        );
    }, [questions, search]);

    const { t } = useTranslation();

    useScrollToActive(containerRef, { center: true });
    return (
        <WidgetPanel
            title={t("debug.panels.goToQuestion.title")}
            searchable
            search={search}
            setSearch={setSearch}
            searchPlaceholder={t("debug.panels.goToQuestion.search")}
            containerRef={containerRef}
        >
            {filteredQuestions
                .filter((q) => q.type != QuestionType.SecuredTemporaryVariable)
                .map(({ name }) => (
                    <div
                        key={name}
                        data-active={firstQuestion?.name === name || undefined}
                        role="button"
                        tabIndex={0}
                        onKeyPress={null}
                        onClick={() =>
                            dispatch(
                                navigationBranchTo({
                                    destination: name,
                                    isPreviewNavigation: true,
                                }),
                            )
                        }
                        className={classNames(
                            classes.question,
                            firstQuestion?.name === name && classes.questionSelected,
                        )}
                    >
                        {name}
                    </div>
                ))}
        </WidgetPanel>
    );
}
